import { NodeViewContent, NodeViewWrapper, type NodeViewProps } from '@tiptap/react'

/** A collapsible section. Always shown open while editing — a writer cannot
 * proof-read content that is hidden behind a summary. */
export function ExpandableView({ node, updateAttributes, editor }: NodeViewProps) {
  return (
    <NodeViewWrapper className="be-expandable" data-sls="expandable">
      <div className="be-expandable__head" contentEditable={false}>
        <span className="be-caret">▾</span>
        <input
          className="be-inline-input"
          value={(node.attrs['title'] as string | null) ?? ''}
          placeholder="Summary shown when collapsed"
          disabled={!editor.isEditable}
          onChange={(e) => updateAttributes({ title: e.target.value || null })}
        />
      </div>
      <NodeViewContent className="be-expandable__body" />
    </NodeViewWrapper>
  )
}
